<template>
  <v-dialog :value="value" v-on:input="$emit('input', $event)" max-width="550px" :persistent="saving">
    <v-form ref="form" v-model="valid">
      <v-card>
        <v-card-title>
          <span v-if="isNew" class="headline">Add language</span>
          <span v-if="!isNew" class="headline">{{ model.name }}</span>
        </v-card-title>
        <v-card-text>
          <v-alert :value="showErrorOnSave" type="error">{{ errorOnSave }}</v-alert>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                        v-model.trim="edited.id"
                        required
                        :rules="[required]"
                        label="Id"
                        :error-messages="errorMessages"
                        :disabled="disabledId"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                        v-model.trim="edited.locale"
                        required
                        :rules="[required]"
                        label="Locale"
                        :error-messages="errorMessages"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                        v-model.trim="edited.name"
                        required
                        :rules="[required]"
                        label="Name"
                        :error-messages="errorMessages"
                        :disabled="saving"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="close">Отменить</v-btn>
          <v-btn color="blue darken-1" flat @click.native="save" :loading="saving">Сохранить</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import { LanguagesApi } from '../common/api'
import { ADD_LANGUAGE, UPDATE_LANGUAGE } from '../store/mutation-types'
import { mapState } from 'vuex'

const COMMON_ERROR = 'Error has occurred while saving'

export default {
  props: ['value', 'model'],
  data () {
    return {
      valid: false,
      saving: false,
      errorMessages: [],
      errorOnSave: COMMON_ERROR,
      showErrorOnSave: false,
      edited: this.defaultModel()
    }
  },
  computed: {
    isNew () {
      return !this.model
    },
    disabledId () {
      return this.saving || !this.isNew
    },
    ...mapState([
      'sections'
    ])
  },
  watch: {
    value () {
      this.showErrorOnSave = false
      this.$refs.form.resetValidation()
      if (!this.value) {
        return
      }
      if (this.isNew) {
        this.edited = this.defaultModel()
      } else {
        this.edited = { ...this.model }
      }
    }
  },
  methods: {
    defaultModel () {
      return {
        id: null,
        locale: null,
        name: ''
      }
    },
    validate () {
      this.errorOnSave = COMMON_ERROR
      return this.$refs.form.validate()
    },
    close () {
      if (this.saving) {
        return
      }
      this.$emit('input', false)
    },
    async save () {
      if (this.saving) {
        return
      }
      if (!this.validate()) {
        return
      }
      this.showErrorOnSave = false
      this.saving = true
      try {
        if (this.isNew) {
          const { data } = await LanguagesApi.create(this.edited)
          this.$store.commit(ADD_LANGUAGE, data)
        } else {
          const { data } = await LanguagesApi.update(this.edited)
          this.$store.commit(UPDATE_LANGUAGE, data)
        }
        this.saving = false
        this.close()
      } catch (e) {
        this.saving = false
        this.showErrorOnSave = true
        console.error(e)
      }
    },
    required (value) {
      return !!value || 'Required.'
    }
  }
}
</script>
